import { render, staticRenderFns } from "./headerPopup.vue?vue&type=template&id=2732e0c0&scoped=true&"
import script from "./headerPopup.vue?vue&type=script&lang=js&"
export * from "./headerPopup.vue?vue&type=script&lang=js&"
import style0 from "./headerPopup.vue?vue&type=style&index=0&id=2732e0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732e0c0",
  null
  
)

/* custom blocks */
import block0 from "./headerPopup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports